import { fetchCityNames } from '../api/spAdmin'

export default {
  data() {
    return {
      cities: ['绥化', '长春', '哈尔滨', '赤峰', '黑河']
    }
  },
  created() {
    this.loadCities()
  },
  methods: {
    loadCities() {
      fetchCityNames().then(list => {
        if (list && list.length) this.cities = list
      }).catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/cities.js